import { Foundation } from 'foundation-sites';
import jquery from 'jquery';
import 'what-input';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = 			jquery;
window.$ = 			jquery;
window.moment = 		require('moment');
window.autosize = 		require('autosize');
window.d3= 			require('d3');
window.jstree= 			require('jstree');
window.datetimepicker = 	require('jquery-datetimepicker');
//require('foundation-sites');
// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
import './lib/foundation-explicit-pieces';

// The link to go to the top of the page
$(window).scroll(function(){
	'use strict';
  	var scroll = $(window).scrollTop();
    if (scroll >= 50) {
        $('.go-top').addClass('show');
    } else {
        $('.go-top').removeClass('show');
    }
});
$('#scrolltop_link').on('click', function(e){
	'use strict';
	e.preventDefault();	
	$('html,body').animate( { scrollTop: 0 }, 'slow');
});

jQuery.datetimepicker.setLocale('en');